module.exports = __webpack_public_path__ + "static/media/individual-placeholder.20377aed.png";